import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Team } from '../../../shared/data/models/collections/team';
import { Seo } from '../../../shared/data/models/components/seo';
import { Request } from '../../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
})
export class TeamComponent extends AbstractLocalizedComponent {
  seo: Seo;
  team: Team;

  constructor(private activatedRoute: ActivatedRoute) {
    super();
  }

  protected loadData(locale: string): void {
    this.collectionsService
      .query<{ teamBySlug: Team }>(Request.TEAM, {
        slug: this.activatedRoute.snapshot.params.slug,
        locale,
      })
      .subscribe(data => {
        this.team = data.teamBySlug;
        this.seo = {
          ...this.team.seo,
          icons: [this.team.displayProfile.family?.icon].concat(this.team.seo.icons),
        };
      });
  }
}
